import FormCurrency from "./FormCurrency.vue";
import FormDraggable from "./FormDraggable.vue";
import FormFile from "./FormFile.vue";
import FormHosSelect from "./FormHosSelect.vue";
import FormImageGallery from "./FormImageGallery/index.vue";
import FormMap from "./FormMap.vue";
import FormMultipleFiles from "./FormMultipleFiles.vue";
import FormMultiSelect from "./FormMultiSelect.vue";
import FormOrgSelect from "./FormOrgSelect.vue";
import FormDashboardSelect from "./FormDashboardSelect.vue";
import FormOrgUserSelect from "./FormOrgUserSelect.vue";
import FormRadiusSearch from "./FormRadiusSearch.vue";
import FormGroupUserSelect from "./FormGroupUserSelect.vue";
import FormJsonEditor from "./FormJsonEditor.vue";
import FormUrlSlug from "./FormUrlSlug.vue";

export default {
	components: {
		FormCurrency,
		FormDraggable,
		FormFile,
		FormHosSelect,
		FormImageGallery,
		FormMap,
		FormMultipleFiles,
		FormMultiSelect,
		FormOrgSelect,
		FormOrgUserSelect,
		FormRadiusSearch,
		FormGroupUserSelect,
		FormDashboardSelect,
		FormJsonEditor,
		FormUrlSlug
	}
};
